import React, { useState, useEffect } from "react";
import TeacherStatBox from "./TeacherStatBox";
import "../styles/TeacherDashboard.css";
import copy_logo from "../images/copy_logo.png";
import download_symbol from "../images/download_symbol_material.png";
import vector from "../images/vector_symbol.png";
import "../styles/TeacherLicenseLabel.css";
import upload_icon from "../images/upload_icon.svg";
import {
  allTeachersViews,
  teacherVideos,
  userProfile,
  anavuViews,
  requestNewLicensekey,
} from "../Services/AllServices";
import { getUserID, getName } from "../Storage/Storage";

const ProfileHeader = ({ showUploadForm, setShowUploadForm }) => {
  const [name, setName] = useState("");
  const [totalViews, setTotalViews] = useState(0);
  const [videosCount, setVideosCount] = useState(0);
  const [user, setUserProfileInfo] = useState({});
  const [copied, setCopied] = useState(false);
  const [anavuViewsCount, setAnavuViews] = useState(0);

  const handleButtonClick = () => setShowUploadForm(true);

  const postLicenseKeyRequest = async () => {
    try {
      const userId = await getUserID();
      const formData = { user_id: userId };
      await requestNewLicensekey(formData, (response) => {
        if (response && response.status === "success") {
          console.log(
            "Generate new license key request sent from teacher!",
            response
          );
        } else {
          console.log("Could not send LK request from teacher");
        }
      });
    } catch (e) {
      console.error("Failed to send LK request from teacher", e);
    }
  };

  const handleGenerateLicenseKey = () => {
    postLicenseKeyRequest();
  };

  const isLicenseExpired = (endDate) => {
    if (!endDate) return false;
    const currentDate = new Date();
    const licenseEndDate = new Date(endDate);
    return licenseEndDate < currentDate;
  };

  const formatDate = (dateString) => {
    if (!dateString) return "NA";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB"); // Formats the date as dd/mm/yyyy
  };

  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const userId = await getUserID();
        const userName = await getName();

        setName(userName);

        const formData = { user_id: userId };
        await allTeachersViews(formData, (response) => {
          if (response && response.status === "success") {
            setTotalViews(response.total_views);
          }
        });
        await userProfile((response) => {
          if (response && response.status === "success") {
            setUserProfileInfo(response.data);
          } else {
            console.log(
              "Failed to load userProfile in teacher profile header",
              response
            );
          }
        });

        await anavuViews(formData, (response) => {
          if (response && response.status === "success") {
            console.log("Anavu Views: ", response);
            setAnavuViews(response.total_views); // Store total views
          } else {
            console.log("No videos yet");
            setAnavuViews(0);
          }
        });

        await teacherVideos(formData, (response) => {
          if (response && response.status === "success") {
            setVideosCount(response.data.totalVideos);
          }
        });
      } catch (error) {
        console.error(
          "Failed to fetch total views or user profile in profile header",
          error
        );
      }
    };

    fetchUserProfile();
  }, []);

  const handleDownload = () => {
    const downloadLink =
      "https://tto-asset.s3.ap-south-1.amazonaws.com/Anavu/BuildFile/anavubuild.zip";
    const anchor = document.createElement("a");
    anchor.href = downloadLink;
    anchor.download = "anavubuild.zip"; // Specify the filename for download
    document.body.appendChild(anchor);
    anchor.click(); // Simulate click to download
    document.body.removeChild(anchor); // Clean up
  };

  const copyToClipboard = () => {
    const licenseKey = user.licensekey || "NA";
    navigator.clipboard.writeText(licenseKey).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1000); // Hide message after 1 second
    });
  };

  return (
    <>
      <div className="profile-header">
        <div className="user-info">
          <h1>{name || "Loading..."}</h1>
          <p>Educator</p>
          {!showUploadForm && (
            <button className="upload_btn" onClick={handleButtonClick}>
              <img
                src={upload_icon}
                alt="Upload Icon"
                className="upload_icon"
              />
              <div className="upload_btn_text">Upload Video</div>
            </button>
          )}
        </div>

        <div className="user-stats">
          <div className="teacher-license-stat-box">
            <div className="teacher-license-header">
              <h2>License Key(Desktop)</h2>
              <button
                className="teacher-license-status-button"
                style={{
                  background: isLicenseExpired(user.licenseEndDate)
                    ? "#FD5454"
                    : "#00B69B",
                }}
              >
                <p>
                  {isLicenseExpired(user.licenseEndDate) ? "Expired" : "Active"}
                </p>
              </button>
            </div>
            <div>
              <div className="teacher-license-key-section">
                <div className="teacher-license-key-copy">
                  <p>&nbsp;{user.licensekey ? user.licensekey : "NA"}</p>
                  <img
                    src={copy_logo}
                    alt="copy logo"
                    onClick={copyToClipboard}
                    style={{ cursor: "pointer" }}
                  />
                  {copied && (
                    <div className="copied-message">Copied!</div> // Temporary message
                  )}
                </div>
              </div>

              <div className="teacher-license-key-section-two">
                <button
                  className="teacher-license-key-button"
                  onClick={handleGenerateLicenseKey}
                >
                  Request new license key
                </button>
                <div className="teacher-license-key-copy-two">
                  <p>
                    Exp: &nbsp;
                    {user.licenseEndDate
                      ? formatDate(user.licenseEndDate)
                      : "NA"}{" "}
                  </p>
                </div>
              </div>

              <div
                className="anavu-license-download-box"
                onClick={handleDownload}
              >
                <div className="anavu-license-download-group">
                  <div className="anavu-license-download-overlap-group">
                    <div className="anavu-license-download-div" />

                    <img
                      className="anavu-license-download-material-symbols"
                      alt="Material symbols"
                      src={download_symbol}
                    />

                    <div className="anavu-license-download-text-wrapper">
                      AnaVu version 1.0
                    </div>

                    <div className="anavu-license-download-ellipse">
                      <img
                        className="anavu-license-download-vector"
                        alt="Vector"
                        src={vector}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <TeacherStatBox
            title="Number of Videos"
            value={(videosCount || 0).toLocaleString()}
          />

          <TeacherStatBox
            title="Total Views"
            value={(totalViews + anavuViewsCount || 0).toLocaleString()}
          />
        </div>
      </div>
    </>
  );
};

export default ProfileHeader;
